import { List, Show, Edit, Toolbar, SaveButton, FilterButton, useNotify, Create, required } from 'react-admin'
import { useWatch } from "react-hook-form";
import { Datagrid, FormDataConsumer, DateField, DateInput, TextField, AutocompleteInput, NumberField, NumberInput, ReferenceInput, SelectField, SelectInput, PasswordInput, BooleanField, EmailField, BooleanInput, SimpleShowLayout, TopToolbar, ListButton, ShowButton, SimpleForm, TextInput} from 'react-admin';

const productSkuFilters = [
    // <TextInput label="Email" source="email" defaultValue="" alwaysOn/>,
    // <SelectInput label="Subject" source="subject" defaultValue="" alwaysOn choices={licenseTypes}/>,
];

export const ProductSkuList = () => (
    <List filters={productSkuFilters}>
        <Datagrid rowClick="show" bulkActionButtons={false}>
            <TextField source="id"/>
            <TextField source="productId" label="Paddle ProductID"/>
            <TextField source="name"/>
            <TextField source="sku"/>
            <NumberField source="trialDays"/>       
        </Datagrid>
    </List>
);

export const ProductSkuShow = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="id"/>
            <TextField source="productId" label="Paddle ProductID"/>
            <TextField source="name"/>
            <TextField source="sku"/>
            <NumberField source="trialDays"/>
        </SimpleShowLayout>
    </Show>
);


const ProductSkuEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);


export const ProductSkuEdit = (props) => {
    const transform = data => ({
        trialDays: data.trialDays
    });

    return (
        <Edit transform={transform} {...props}>
            <TextField source="name"/>
            <SimpleForm toolbar={<ProductSkuEditToolbar />}>
                <NumberInput source="trialDays" min={0} validate={required()}/>
            </SimpleForm>
        </Edit>
    );
}